import { Link, useNavigate } from 'react-router-dom';

export default function AddProfileChoice() {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="text-center py-16">
        <span className="text-6xl">🎉</span>
        <h2 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">
          A new addition to your family!
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          What would you like to track?
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
          <Link
            to="/app/baby/create"
            className="flex-1 card p-6 text-center hover:shadow-lg hover:border-primary-300 dark:hover:border-primary-600 transition-all border-2 border-transparent hover:border-primary-400"
          >
            <span className="text-5xl block mb-3">👶</span>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Baby</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Track feeds, nappies, sleep, and more for your newborn
            </p>
          </Link>
          <Link
            to="/app/pregnancy/new"
            className="flex-1 card p-6 text-center hover:shadow-lg hover:border-pink-300 dark:hover:border-pink-600 transition-all border-2 border-transparent hover:border-pink-400"
          >
            <span className="text-5xl block mb-3">🤰</span>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Pregnancy</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Track symptoms, appointments, kicks, and your pregnancy journey
            </p>
          </Link>
        </div>
        <button
          onClick={() => navigate(-1)}
          className="mt-6 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
